var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageUnread(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3C1 2.44772 1.44772 2 2 2H17C17.5523 2 18 2.44772 18 3C18 3.55228 17.5523 4 17 4H3V17H9.5C9.76522 17 10.0196 17.1054 10.2071 17.2929L12 19.0858L13.7929 17.2929C13.9804 17.1054 14.2348 17 14.5 17H21V8C21 7.44772 21.4477 7 22 7C22.5523 7 23 7.44772 23 8V18C23 18.5523 22.5523 19 22 19H14.9142L12.7071 21.2071C12.3166 21.5976 11.6834 21.5976 11.2929 21.2071L9.08579 19H2C1.44772 19 1 18.5523 1 18V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 10C10.5 9.44772 10.9477 9 11.5 9H12.5013C13.0535 9 13.5013 9.44772 13.5013 10C13.5013 10.5523 13.0535 11 12.5013 11H11.5C10.9477 11 10.5 10.5523 10.5 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5005 10C15.5005 9.44772 15.9482 9 16.5005 9H17.4999C18.0522 9 18.4999 9.44772 18.4999 10C18.4999 10.5523 18.0522 11 17.4999 11H16.5005C15.9482 11 15.5005 10.5523 15.5005 10Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50049 10C5.50049 9.44772 5.9482 9 6.50049 9H7.49994C8.05222 9 8.49994 9.44772 8.49994 10C8.49994 10.5523 8.05222 11 7.49994 11H6.50049C5.9482 11 5.50049 10.5523 5.50049 10Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 5C22.3284 5 23 4.32843 23 3.5C23 2.67157 22.3284 2 21.5 2C20.6716 2 20 2.67157 20 3.5C20 4.32843 20.6716 5 21.5 5Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageUnread);
export default __webpack_public_path__ + "static/media/message-unread.a476d01b0b108a4b57e6677cfc639578.svg";
export { ForwardRef as ReactComponent };